/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSignalLte = createReactComponent("outline", "signal-lte", "IconSignalLte", [["path", { "d": "M21 8h-4v8h4", "key": "svg-0" }], ["path", { "d": "M17 12h2.5", "key": "svg-1" }], ["path", { "d": "M4 8v8h4", "key": "svg-2" }], ["path", { "d": "M10 8h4", "key": "svg-3" }], ["path", { "d": "M12 8v8", "key": "svg-4" }]]);

export { IconSignalLte as default };
//# sourceMappingURL=IconSignalLte.mjs.map
